export const THEME_IDS = ['light', 'dark', 'midnight', 'sunrise'] as const;

export type ThemeId = (typeof THEME_IDS)[number];

/** localStorage key next-themes persists the device choice under. */
export const APP_THEME_STORAGE_KEY = 'app-theme';

export function isThemeId(value: string): value is ThemeId {
  return (THEME_IDS as readonly string[]).includes(value);
}

export interface AppTheme {
  id: ThemeId;
  label: string;
  isDark: boolean;
  preview: [string, string, string];
}

export const APP_THEMES: AppTheme[] = [
  {
    id: 'light',
    label: 'Light',
    isDark: false,
    preview: ['#f7f8f7', '#35B89B', '#3C4242'],
  },
  {
    id: 'dark',
    label: 'Dark',
    isDark: true,
    preview: ['#141820', '#35B89B', '#e2e4e4'],
  },
  {
    id: 'midnight',
    label: 'Midnight',
    isDark: true,
    preview: ['#0d1117', '#60a5fa', '#94a3b8'],
  },
  {
    id: 'sunrise',
    label: 'Sunrise',
    isDark: false,
    preview: ['#fff7ed', '#fb923c', '#ea580c'],
  },
];
